







































































































import { Component } from 'vue-property-decorator';
import { DepositAccountModule } from '@/store/Accounts/DepositAccountModule';
import SaascadaVue from '@/components/Shared/SaascadaVue';
import Mandate from '@/models/Accounts/DepositAccounts/Mandates/Mandate';
import MandateState from '@/components/Accounts/DepositAccounts/Mandates/MandateState.vue';

@Component({ name: 'Mandates', components: { MandateState } })
export default class extends SaascadaVue {

    headers = [
        { text: this.$t('pageText.depositAccounts.fields.reference'), width: '40%', sortable: false },
        { text: this.$t('pageText.depositAccounts.fields.payerName'), width: '30%', sortable: false },
        { text: this.$t('pageText.depositAccounts.fields.createdAt'), width: '30%', sortable: false }
    ];
    mandatesPage = 1;

    async beforeMount() {
        await DepositAccountModule.getMandates();
    }

    get mandates() {
        return DepositAccountModule.mandates;
    }

    get mandate() {
        return DepositAccountModule.mandate;
    }

    get loading() {
        return DepositAccountModule.loadingMandates;
    }

    get totalMandatePages() {
        return DepositAccountModule.totalMandatePages;
    }

    get pageSize() {
        return DepositAccountModule.pageSize;
    }

    updateCurrentMandate(mandate: Mandate) {
        DepositAccountModule.updateMandate(mandate);
    }

}
